module.exports = __webpack_public_path__ + "media/images/icon_list/bold-bce2a441b6d34e73198441c0f0668da5.svg";